var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#FCA5A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.329 33.0007C27.262 33.0007 27.193 32.9977 27.124 32.9907C26.244 32.9037 25.554 32.2827 25.364 31.4077L22.681 19.0157L19.918 25.3977C19.759 25.7637 19.398 26.0007 19 26.0007H16C15.447 26.0007 15 25.5527 15 25.0007C15 24.4477 15.447 24.0007 16 24.0007H18.344L20.85 18.2117C21.205 17.3957 21.987 16.9207 22.876 17.0097C23.756 17.0967 24.446 17.7177 24.636 18.5927L27.319 30.9847L30.082 24.6027C30.241 24.2367 30.601 24.0007 31 24.0007H34C34.553 24.0007 35 24.4477 35 25.0007C35 25.5527 34.553 26.0007 34 26.0007H31.656L29.15 31.7887C28.823 32.5417 28.122 33.0007 27.329 33.0007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAlerts);
export default __webpack_public_path__ + "static/media/price-alerts.aed81fe07a305c55bef769d768d31ebf.svg";
export { ForwardRef as ReactComponent };